import { FETCH_CONDITIONS_REQUESTED } from './../../condition/list/list.actions';
import { FETCH_SIZES_REQUESTED, FILTER_SIZE_REQUESTED } from './../../size/list/list.actions';
import { FETCH_PROCESS_STATUSES_REQUESTED } from './../../process-status/list/list.actions';
import { GET_ALL_CONDITIONS_REQUESTED } from './../../condition/condition.actions';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { GET_ALL_SIZES_REQUESTED } from './../../size/size.actions';
import { GET_ALL_PROCESS_STATUSES_REQUESTED } from './../../process-status/process-status.actions';

import store from './../../../store/store.module';
import {
  FETCH_PRODUCTS_REQUESTED,
  DOWNLOAD_REQUESTED,
  FILTER_PRODUCTS_BY_STATUS,
  FETCH_PARTNER_PRODUCT_REQUESTED,
  SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED,
  BULK_UPDATE_PRODUCT_SUCCEEDED,
  BULK_UPDATE_PRODUCT_REQUESTED,
  BULK_UPDATE_PRODUCT_FAILED,
  REINDEX_PRODUCT_REQUESTED,
  SELECT_ALL_VISIBLE_PRODUCT,
  REINDEX_SELECTED_PRODUCT_ITEM,
  SELECT_ALL_PRODUCT,
  RESET_PRODUCT_SELECTION,
  START_GLOBAL_SALE_REQUESTED,
  STOP_GLOBAL_SALE_REQUESTED
} from './list.actions';
import * as _ from 'lodash';
import { GET_ALL_CATEGORIES_REQUESTED } from '../../category/category.actions';
import { GET_ALL_DESIGNERS_REQUESTED } from '../../designer/designer.actions';
import { PRINT_REQUEST } from '../../../store/print/print.actions';
import { GET_ALL_STYLES_REQUESTED } from '../../style/style.actions';
import { FETCH_CONSTANTS_REQUESTED } from '../../../store/constant/list/list.actions';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { BarcodeComponent } from '../../../common/print-template/product-barcode/barcode.component';
import { GET_ALL_COLORS_REQUESTED } from '../../color/color.action';
import { GET_ALL_WARDROBES_REQUESTED } from '../../wardrobe/wardrobe.action';
import { MultiSearchAction } from '../../../models/MultiSearchAction';
import { Subscription } from 'rxjs/Subscription';
import { FETCH_PROCESS_TYPES_REQUESTED } from '../../process-types/list/list.actions';
import { ADD_HISTORY_SUCCEEDED } from '../product.action';
import { PRODUCT_COMP } from '../product.const';
import {AvailablePermissions} from "../../../app.const";
import {environment} from "../../../../environments/environment";
import Redirect from "../../../models/Redirect";
import {UtilityService} from "../../../common/services/utility/utility.service";
import {AppInjector} from "../../../app-injector";
import {ApiService} from "../../../api/api.service";
import {SELECT_ALL_PAYMENT, SELECT_ALL_VISIBLE_PAYMENT} from "../../payment/list/list.actions";
import {Subject} from "rxjs";
import {debounceTime} from "rxjs/operators";
import {FILTER_USERS_REQUESTED} from "../../user/list/list.actions";
import {COLLECTION_COMP} from "../../collection/collection.const";
import {POPULATE_CONFIRM_ORDER_REQUESTED} from "../../order/edit/edit.actions";
declare let $: any;

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  public store = store;

  private filters = {};
  public productCreatePermission = [AvailablePermissions.PRODUCT_CREATE];
  public productCreateAllPermission = [AvailablePermissions.PRODUCT_CREATE_ALL];
  public productUpdateAllPermission = [AvailablePermissions.PRODUCT_UPDATE_ALL];
  public uploaderUrl = environment.imageUploadUrl;
  public userSubject = new Subject<string>();
  protected defaultBulkUpdate = Object.freeze({
    enabled: null,
    approved: null,
    process_status_id: null,
    wardrobe_id: null
  });
  protected defaultFilters = Object.freeze({
    size_group_id: '',
    size_group_gender: '',
    size_group_age_group: '',
    condition_id: '',
    color_id: '',
    designer_id: '',
    process_status_id: '',
    style_id: '',
    category_ids: '',
    wardrobe_ids: '',
    process_type_id: '',
    process_statuses: '',
    approved: '',
    enabled: '',
    ready_vip: null,
    ready_diy: null,
    wishlist_user_id: '',
    created_at_between: [new Date(), new Date()],
    partner_product_filter: null
  });
  protected defaultOrders = Object.freeze({
    sku: null,
    enabled: null,
    approved: null,
    id: null,
    name: null,
    price: null,
    condition: null,
    designer: null,
    size: null,
    color: null,
    process_status: null,
    updated_at: null,
    created_at: null,
    last_process_status_update: null,
    default: null
  });
  public untouched = true;
  public filterOrderUntouched = true;
  public temporaryFilterHolder = { ...this.defaultFilters };
  public isViewAllFilter = false;
  protected orders = { ...this.defaultOrders };

  public bulkUpdate = {
    ...this.defaultBulkUpdate
  };

  public search_actions = _.map(
    [
      {
        label: 'Keyword',
        placeholder: 'Search by product name'
      },
      {
        label: 'Seller Email',
        queryParamKey: 'seller_email',
        placeholder: 'Search by product seller email'
      },
      {
        label: 'Collection Number',
        queryParamKey: 'collection_id',
        placeholder: 'Search by collection number'
      }
    ],
    action => new MultiSearchAction(action)
  );

  public isOpen = false;
  public navigationSubscription: Subscription;
  public uploadFilePercentage = 0;
  constructor(private notification: NotificationService, private activatedRoute: ActivatedRoute, private router: Router, public utilityService: UtilityService) {
    this.activatedRoute = activatedRoute;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      this.filters = {};
      this.filterOrderUntouched = true;
      this.temporaryFilterHolder = { ...this.defaultFilters };
      if (!_.isUndefined(this.activatedRoute.snapshot.queryParams.filter_order_status)) {
        this.filters['process_statuses'] = this.activatedRoute.snapshot.queryParams.filter_order_status;
      }
      let filters;
      const redirectData = this.utilityService.getRedirectData();
      if (!_.isUndefined(this.activatedRoute.snapshot.queryParams.filters)) {
        filters = this.activatedRoute.snapshot.queryParams.filters;
      } else if (redirectData && redirectData.defaultValue && redirectData.defaultValue['filters']) {
        filters = redirectData.defaultValue['filters'];
      }
      if (filters) {
        let tmp = JSON.parse(filters);
        Object.keys(tmp).forEach((key) => {
          this.filterOrderUntouched = false;
          if (typeof tmp[key] === 'object') {
            if (Object.keys(tmp[key]).length > 0) {
              this.filters[key] = tmp[key];
              Object.keys(tmp[key]).forEach(s => {
                this.temporaryFilterHolder[key + '_' + s] = tmp[key][s];
              });
            }
          } else {
            this.filters[key] = tmp[key];
            this.temporaryFilterHolder[key] = tmp[key];
          }
        });
      }
      if (!this.filters['process_status_id']) {
        this.filters['hasprocessstatus'] = true;
      } else {
        this.filters['hasprocessstatus'] = false;
      }
      if (!_.isUndefined(this.activatedRoute.snapshot.queryParams.orders)) {
        let orders = this.activatedRoute.snapshot.queryParams.orders;
        if (orders) {
          this.orders = JSON.parse(orders);
        }
      }
      if (e instanceof NavigationEnd) {
        if (!_.isUndefined(this.activatedRoute.snapshot.queryParams.untouched)) {
          this.untouched = false;
        }
        store.dispatch({
          type: FETCH_PRODUCTS_REQUESTED,
          data: {
            filter: this.filters,
            sort: this.orders,
            pagination: this.getQuery(),
            untouched: this.untouched
          }
        });
        store.dispatch({
          type: ADD_HISTORY_SUCCEEDED,
          data: {
            filter: this.filters,
            sort: this.orders,
            pagination: this.getQuery()
          }
        });
        store.dispatch({ type: FETCH_PARTNER_PRODUCT_REQUESTED });
        store.dispatch({ type: GET_ALL_PROCESS_STATUSES_REQUESTED });
        store.dispatch({ type: GET_ALL_WARDROBES_REQUESTED });
        store.dispatch({ type: GET_ALL_CATEGORIES_REQUESTED });
        store.dispatch({ type: GET_ALL_DESIGNERS_REQUESTED });
        store.dispatch({ type: GET_ALL_STYLES_REQUESTED });
        store.dispatch({ type: GET_ALL_SIZES_REQUESTED });
        store.dispatch({ type: GET_ALL_CONDITIONS_REQUESTED });
        store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });
        store.dispatch({ type: GET_ALL_COLORS_REQUESTED });
        store.dispatch({ type: FETCH_PROCESS_TYPES_REQUESTED });

        this.bulkUpdate = {
          ...this.defaultBulkUpdate
        };
        this.untouched = false;
      }
    });

  }

  ngOnInit() {
    let queryParams = this.activatedRoute.snapshot.queryParams;
    if (!_.isUndefined(queryParams.open)) {
      this.isOpen = queryParams.open;
    }
    this.subscribeToUser();
  }

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }
  viewMoreFilter() {
    this.isViewAllFilter = !this.isViewAllFilter;
  }
  onImageError() {
  }
  getCheckedIds() {
    let curItems = store.getState().Product.list.items;
    let curItemIds = curItems.map(s => s.id);
    let checkedItems = store.getState().Product.list.checkedItems
      .filter(s => s.checked === true)
      .filter(s => curItemIds.indexOf(s.id) === -1)
      .map(s => s.id);
    return checkedItems.concat(curItems.filter(s => s.checked === true).map(s => s.id));
  }
  isAllChecked() {
    return store.getState().Product.list.allChecked;
  }
  getSelectedNum() {
    if (store.getState().Product.list.fetched) {
      if (this.isAllChecked()) {
        return store.getState().Product.list.pagination.total;
      } else {
        return this.getCheckedIds().length;
      }
    } else {
      return 0;
    }
  }
  resetSelected() {
    store.dispatch({ type: RESET_PRODUCT_SELECTION });
  }
  getSelectText() {
    if (store.getState().Product.list.allChecked) {
      return `Select products on this page`;
    } else {
      return `Select all ${store.getState().Product.list.pagination.total} products`;
    }
  }
  toggleAllproducts() {
    if (store.getState().Product.list.allChecked) {
      store.dispatch({ type: SELECT_ALL_VISIBLE_PRODUCT, data: true });
    } else {
      store.dispatch({ type: SELECT_ALL_PRODUCT });
    }
  }
  newProductNonAdmin() {
    let processType = store.getState().ProcessType.list.items.find(s => s.name === store.getState().Auth.login.profile.customer.group);
    this.utilityService.nextPageWithReferer(['/product/wizard/1'], new Redirect('/product', {
      seller_id: store.getState().Auth.login.profile.id,
      ...(processType ? {process_type_id: processType.id} : {})
    }));
  }
  subscribeToBulkUploadReceipt() {
    let unsubscribe = store.subscribe(() => {
      let observedCode = (store as any).getState().Product.list.bulkUpdateReceipt;
      if (observedCode) {
        this.uploadFilePercentage = 0;
        AppInjector.get(ApiService).general.asyncStatus(observedCode, 1000, (val) => {
          this.uploadFilePercentage = val.data.percentage;
        }).subscribe(s => {
          if (s !== 'Time out') {
            store.dispatch({ type: BULK_UPDATE_PRODUCT_SUCCEEDED });
          } else {
            store.dispatch({ type: BULK_UPDATE_PRODUCT_FAILED });
          }
          unsubscribe();
          this.uploadFilePercentage = 0;
          this.bulkUpdate = {
            ...this.defaultBulkUpdate
          };
          store.dispatch({
            type: FETCH_PRODUCTS_REQUESTED,
            data: {
              filter: this.filters,
              sort: this.orders,
              pagination: this.getQuery()
            }
          });
        });
      }
    });
  }


  isNotAvailable(datum) {
    return (_.isNil(datum) || datum === 'undefined');
  }

  public getQuery(): object {
    let supportedParams = ['sort', 'constraints', 'page', 'per_page', 'search', 'skus'];
    let queryParams = { page: 1 };
    if (_.keys(this.activatedRoute.snapshot.queryParams).length > 0) {
      queryParams = _.assign(queryParams, this.activatedRoute.snapshot.queryParams);
    }
    return _.pick(queryParams, supportedParams);
  }

  sortBy(field) {
    // tslint:disable-next-line:forin
    let query = [];
    for (let prop in this.orders) {
      if (prop === field) {
        if (this.orders[field] === null) {
          this.orders[field] = '-';
        } else {
          if (this.orders[field] === '-') {
            this.orders[field] = '';
          } else if (this.orders[field] === '') {
            this.orders[field] = null;
          }
        }
      }
    }
    this.filterOrderUntouched = false;
    this.router.navigate(['product'], { queryParams: this.getCurrentQueryString()});
  }

  filter(key, value) {
    if (value === '') {
      delete this.filters[key];
    } else {
      this.filters[key] = value;
    }
    this.filterOrderUntouched = false;
    this.router.navigate(['product'], { queryParams: this.getCurrentQueryString()});
  }

  filterWishlist(value) {
    if (value === null) {
      value = '';
    }
    this.filter('wishlist_user_id', value);
  }

  public getCurrentQueryString() {
    let params = {
      filters: JSON.stringify(this.filters),
      orders: JSON.stringify(this.orders)
    };
    if (this.activatedRoute.snapshot.queryParams.search) {
      params['search'] = this.activatedRoute.snapshot.queryParams.search;
    }
    return params;
  }

  filter_group(group, key, value) {
    if (typeof this.filters[group] === 'undefined') {
      this.filters[group] = {};
    }
    if (value === '') {
      delete this.filters[group][key];
    } else {
      this.filters[group][key] = value;
    }
    this.filterOrderUntouched = false;
    this.router.navigate(['product'], { queryParams: this.getCurrentQueryString()});

    if (group === 'size_group' && this.filters['size_group']) {
      store.dispatch({ type: FILTER_SIZE_REQUESTED, data: { filter: { gender: this.filters['size_group'].gender, age_group: this.filters['size_group'].age_group } } });
    }
  }
  selectAllProducts(event) {
    store.dispatch({ type: SELECT_ALL_VISIBLE_PRODUCT, data: event.checked });
  }
  print(product) {
    store.dispatch({ type: PRINT_REQUEST, data: { values: [{
      sku: product.sku,
      price: product.original_price,
      stPrice: product.price,
      size: product.size
    }] }, component: BarcodeComponent });
  }

  resetFilter() {
    this.filters = {};
    this.orders = { ...this.defaultOrders };
    this.temporaryFilterHolder = { ...this.defaultFilters };
    this.filterOrderUntouched = true;
    this.router.navigate(['product'], { queryParams: this.getCurrentQueryString()});
  }

  downloadCSV() {
    store.dispatch({ type: REINDEX_SELECTED_PRODUCT_ITEM });
    let data = {};
    if (!this.isAllChecked()) {
      if (this.getCheckedIds().length > 0) {
        data = {
          filter: {
            containid: this.getCheckedIds().join(',')
          },
          pagination: {
            search: null
          }
        };
      } else {
        this.notification.show('warning', 'nothing selected', 3000);
      }
    } else {
      data = {
        pagination: {
          search: this.getQuery()['search']
        },
        filter: this.filters,
        sort: this.orders
      };
    }
    store.dispatch({
      type: DOWNLOAD_REQUESTED, data: {
        mediaPath: store.getState().RootReducer.config.mediaUrl,
        type: 'product',
        ...data
      }
    });
  }

  downloadAttributes() {
    store.dispatch({
      type: DOWNLOAD_REQUESTED, data: {
        mediaPath: store.getState().RootReducer.config.mediaUrl,
        type: 'product_attributes'
      }
    });
  }
  updateStatus({process_status_id, enabled, approved, wardrobe_id}) {
    store.dispatch({ type: REINDEX_SELECTED_PRODUCT_ITEM });
    if (this.isNotAvailable(process_status_id) && this.isNotAvailable(enabled) && this.isNotAvailable(wardrobe_id) && this.isNotAvailable(approved)) {
      this.notification.show('warning', 'nothing to change', 3000);
      return;
    }
    if (!this.isAllChecked()) {
      if (_.isNil(this.getCheckedIds()) || this.getCheckedIds().length === 0) {
        this.notification.show('warning', 'Please select product', 3000);
        return;
      }
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            filter: {
              containid: this.getCheckedIds().join(',')
            },
            pagination: {
              search: null
            }
          },
          ...(this.isNotAvailable(process_status_id) ? {} : {process_status_id: process_status_id}),
          ...(this.isNotAvailable(enabled) ? {} : {enabled: enabled}),
          ...(this.isNotAvailable(approved) ? {} : {approved: approved}),
          ...(this.isNotAvailable(wardrobe_id) ? {} : {wardrobe_id: wardrobe_id})
        }
      });
    } else {
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            pagination: {
              search: this.getQuery()['search']
            },
            filter: this.filters,
            sort: this.orders
          },
          ...(this.isNotAvailable(process_status_id) ? {} : {process_status_id: process_status_id}),
          ...(this.isNotAvailable(enabled) ? {} : {enabled: enabled}),
          ...(this.isNotAvailable(approved) ? {} : {approved: approved}),
          ...(this.isNotAvailable(wardrobe_id) ? {} : {wardrobe_id: wardrobe_id})
        }
      });
    }
  }
  setAsEditorsPick() {
    store.dispatch({ type: REINDEX_SELECTED_PRODUCT_ITEM });
    if (!this.isAllChecked()) {
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            filter: {
              containid: this.getCheckedIds().join(',')
            },
            pagination: {
              search: null
            }
          },
          style_name: "EDITOR'S PICKS"
        }
      });
    } else {
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            pagination: {
              search: this.getQuery()['search']
            },
            filter: this.filters,
            sort: this.orders
          },
          style_name: "EDITOR'S PICKS"
        }
      });
    }
  }
  removeFromEditorsPick() {
    store.dispatch({ type: REINDEX_SELECTED_PRODUCT_ITEM });
    if (!this.isAllChecked()) {
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            filter: {
              containid: this.getCheckedIds().join(',')
            },
            pagination: {
              search: null
            }
          },
          remove_style_name: "EDITOR'S PICKS"
        }
      });
    } else {
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            pagination: {
              search: this.getQuery()['search']
            },
            filter: this.filters,
            sort: this.orders
          },
          remove_style_name: "EDITOR'S PICKS"
        }
      });
    }
  }
  bump(type = 'normal') {
    store.dispatch({ type: REINDEX_SELECTED_PRODUCT_ITEM });
    if (!this.isAllChecked()) {
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            filter: {
              containid: this.getCheckedIds().join(',')
            },
            pagination: {
              search: null
            }
          },
          bump: type === 'normal',
          sale_bump: type === 'sale'
        }
      });
    } else {
      this.subscribeToBulkUploadReceipt();
      store.dispatch({
        type: BULK_UPDATE_PRODUCT_REQUESTED,
        data: {
          product_query: {
            pagination: {
              search: this.getQuery()['search']
            },
            filter: this.filters,
            sort: this.orders
          },
          bump: type === 'normal',
          sale_bump: type === 'sale'
        }
      });
    }
  }
  sendToQueue(partnerId) {
    store.dispatch({ type: REINDEX_SELECTED_PRODUCT_ITEM });
    if (_.isNil(this.getCheckedIds()) || this.getCheckedIds().length === 0) {
      this.notification.show('warning', 'Please select product', 3000);
      return false;
    }
    store.dispatch({
      type: SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED,
      data: {
        product_ids: this.getCheckedIds(),
        partner_id: partnerId
      }
    });
  }

  reindexFrontEnd() {
    store.dispatch({ type: REINDEX_PRODUCT_REQUESTED });
  }

  startGlobalSale() {
    store.dispatch({ type: START_GLOBAL_SALE_REQUESTED });
  }

  stopGlobalSale() {
    store.dispatch({ type: STOP_GLOBAL_SALE_REQUESTED });
  }

  populateConfirmOrder() {
    store.dispatch({ type: POPULATE_CONFIRM_ORDER_REQUESTED});
    this.notification.show('success', 'Populating sold confirm products', 3000);
  }

  filterProductByStatus() {
    const data = store.getState().ProcessStatus.all.items;
    store.dispatch({ type: FILTER_PRODUCTS_BY_STATUS, field: 'status', data: data });
  }

  editProduct(id) {
    this.utilityService.nextPageWithReferer(['/product/edit/' + id], new Redirect('product', {}, PRODUCT_COMP, { queryParams: this.getCurrentQueryString()}));
  }
  subscribeToUser() {
    this.userSubject.pipe(
      debounceTime(500),
    ).subscribe(term => {
      if (term) {
        store.dispatch({ type: FILTER_USERS_REQUESTED, com: COLLECTION_COMP, data: { pagination: { page: 1, per_page: 10}, sort: null, filter: null, search: term }});
      } else {
        store.dispatch({ type: FILTER_USERS_REQUESTED, com: COLLECTION_COMP, data: { pagination: { page: 1, per_page: 10}, sort: null, filter: null, search: null }});
      }
    }, () => {
    });
  }
}
